/* eslint-disable import/no-unused-modules */
import colors from 'theme/_colors.scss';

export const pageSize = 1000;

export const filterActionTypes = {
    SET_FLEET_FILTERS: 'fleetsDashboard/SET_FLEET_FILTERS',
    GET_FLEET_ASSET_GROUP: 'fleetsDashboard/GET_FLEET_ASSET_GROUP',
    GET_FLEET_DATA: 'fleetsDashboard/GET_FLEET_DATA',
    SET_FLEET_LOADING: 'fleetsDashboard/SET_FLEET_LOADING',
    SET_SELECTED_FLEET: 'fleetsDashboard/SET_SELECTED_FLEET',
    SET_INITIAL_LOAD_DASHBOARD: 'fleetsDashboard/SET_INITIAL_LOAD_DASHBOARD',
    SET_DASHBOARD_REFRESH_ANALYTICS: 'fleetsDashboard/SET_DASHBOARD_REFRESH_ANALYTICS',
    SET_FLEET_MULTI_LEVEL_FILTERS: 'fleetsDashboard/SET_FLEET_MULTI_LEVEL_FILTERS',
    REFRESH_FLEET_CONDITION: 'fleetsDashboard/REFRESH_FLEET_CONDITION',
    REFRESH_FLEET_ALL: 'fleetsDashboard/REFRESH_FLEET_ALL',
    SET_DASHBOARD_REFRESH_ORIGIN: 'fleetsDashboard/SET_DASHBOARD_REFRESH_ORIGIN',
    SET_LAST_UPDATED_TIMESTAMP: 'fleetsDashboard/SET_LAST_UPDATED_TIMESTAMP',
};

export const customerTypes = {
    PriorityCustomers: 'Priority Customers',
    SensitiveCustomers: 'Sensitive Customers',
};

export const assetStatus = {
    GOOD: 'Good',
    TOLERABLE: 'Tolerable',
    POOR: 'Poor',
    UNKNOWN: 'Unknown',
    UNSUPPORTED: 'Unsupported'
};

export const connectivityStatus = {
    CONNECTED: 'Connected',
    DISCONNECTED: 'Disconnected',
    UNKNOWN: 'Unknown',
    UNSUPPORTED: 'Unsupported',
    ONLINE: 'Online',
    OFFLINE: 'Offline',
    ROTATINGEQUIPMENTS_ONLINE: 'ROTATINGEQUIPMENTS_ONLINE',
    ROTATINGEQUIPMENTS_OFFLINE: 'ROTATINGEQUIPMENTS_OFFLINE',
    DRIVES_ONLINE: 'DRIVES_ONLINE',
    DRIVES_OFFLINE: 'DRIVES_OFFLINE',
};

export const assetStateColors = {
    [assetStatus.GOOD]: colors.jungleGreenTransparent2,
    [assetStatus.TOLERABLE]: colors.orangePeel,
    [assetStatus.POOR]: colors.primaryError,
    [assetStatus.UNKNOWN]: colors.neutralGray,
    [assetStatus.UNSUPPORTED]: colors.silver
};

export const connectivityStateColors = {
    [connectivityStatus.CONNECTED]: colors.primaryInfo,
    [connectivityStatus.DISCONNECTED]: colors.primaryInfoTransparent2,
    [connectivityStatus.ONLINE]: colors.primaryInfo,
    [connectivityStatus.OFFLINE]: colors.primaryInfoTransparent2,
    [connectivityStatus.UNKNOWN]: colors.neutralGray,
    [connectivityStatus.UNSUPPORTED]: colors.silver,
    [connectivityStatus.ROTATINGEQUIPMENTS_ONLINE]: colors.globalBlue,
    [connectivityStatus.ROTATINGEQUIPMENTS_OFFLINE]: colors.silver,
    [connectivityStatus.DRIVES_ONLINE]: colors.primaryInfo,
    [connectivityStatus.DRIVES_OFFLINE]: colors.doveGray
};

export const FLEET_NAME_MAX_LENGTH = 30;
export const NAME_REGEX = /(?=[A-Z])/;

export const filterKeys = {
    siteId: 'siteId',
    countryCode: 'countryCode',
    organizationId: 'organizationId',
    owner: 'owner'
};

export const refreshConditions = {
    condition: 'condition',
    all: 'all'
};
